export const P00080PositionTypeEnum = [
  { ref: 0, label: 'P00080.positiontype.0' },
  { ref: 1, label: 'P00080.positiontype.1' },
];
